function normalizeList(value) {
  if (Array.isArray(value)) {
    return value;
  }

  if (value && typeof value === 'object') {
    return Object.values(value);
  }

  return [];
}

export function mapTaskSchedulesResponseToDto(payload) {
  return normalizeList(payload?.tasks).map((item, index) => ({
    task: String(item?.task || `task-${index}`).trim(),
    label: String(item?.label || item?.task || '').trim(),
    cronExpression: String(item?.cronExpression || item?.cron_expression || '').trim(),
    nextRunAt: item?.nextRunAt || item?.next_run_at || null,
    lastRunAt: item?.lastRunAt || item?.last_run_at || null,
    isActive: Boolean(item?.isActive ?? item?.is_active),
  })).filter((item) => item.task);
}

export function mapTaskScheduleResponseToDto(payload) {
  const item = payload?.task;
  if (!item || typeof item !== 'object') {
    return null;
  }

  return {
    task: String(item.task || '').trim(),
    label: String(item.label || item.task || '').trim(),
    cronExpression: String(item.cronExpression || item.cron_expression || '').trim(),
    nextRunAt: item.nextRunAt || item.next_run_at || null,
    lastRunAt: item.lastRunAt || item.last_run_at || null,
    isActive: Boolean(item.isActive ?? item.is_active),
  };
}

export function buildTaskSchedulePayloadFromRow(row) {
  return {
    cronExpression: String(row?.draftCronExpression || '').trim(),
  };
}

export function buildTaskScheduleStatusPayload(isActive) {
  return {
    isActive: Boolean(isActive),
  };
}

export function validateTaskSchedulePayload(payload) {
  const cronExpression = String(payload?.cronExpression || '').trim();
  if (!cronExpression) {
    return {
      cronExpression: 'Cron expression is required.',
    };
  }

  return {};
}

export function mapTaskScheduleFieldErrors(error) {
  const result = {};

  (error?.errors || []).forEach((item) => {
    const parameter = String(item?.parameter || '').trim();
    if (!parameter) {
      return;
    }

    const normalized = parameter.split('.').pop();
    if (!normalized) {
      return;
    }

    result[normalized] = item.message || 'Invalid value';
  });

  return result;
}
